import { useQuery } from '@tanstack/react-query';
import { fetchEmployerApplicants, type EmployerApplicant } from '../api/employerApplicants';

export function useEmployerApplicants(jobId?: string | number) {
  return useQuery<EmployerApplicant[]>({
    queryKey: ['employer-applicants', jobId ?? 'all'],
    queryFn: () => fetchEmployerApplicants(jobId),
    enabled: jobId === undefined || Boolean(jobId),
    staleTime: 1000 * 30,
  });
}
